import Blockly from 'blockly'

//文本基础元素
Blockly.Blocks['text'] = {
  init: function() {
    this.jsonInit({
      type: 'text',
      message0: '%1',
      args0: [
        {
          type: 'field_input',
          name: 'TEXT',
          text: '',
        },
      ],
      output: 'String',
      style: 'text_blocks',
      helpUrl: '%{BKY_TEXT_TEXT_HELPURL}',
      tooltip: '%{BKY_TEXT_TEXT_TOOLTIP}',
      extensions: ['text_quotes', 'parent_tooltip_when_inline'],
    })
  },
}

//  新建字符串
Blockly.Blocks['text_append'] = {
  init: function() {
    this.jsonInit({
      message0: '%{BKY_TEXT_APPEND_TITLE}',
      args0: [
        {
          type: 'field_variable',
          name: 'VAR',
          variable: '%{BKY_TEXT_APPEND_VARIABLE}',
        },
        {
          type: 'input_value',
          name: 'TEXT',
        },
      ],
      previousStatement: null,
      nextStatement: null,
      inputsInline: true,
      style: 'text_blocks',
      helpUrl: Blockly.Msg['TEXT_APPEND_HELPURL'],
      extensions: ['text_append_tooltip'],
    })
  },
}
//  字符串的长度
Blockly.Blocks['text_length'] = {
  init: function() {
    this.jsonInit({
      message0: '\u180e%{BKY_TEXT_LENGTH_TITLE}',
      args0: [
        {
          type: 'input_value',
          name: 'VALUE',
          check: ['String', 'Array'],
        },
      ],
      output: 'Number',
      style: 'text_blocks',
      tooltip: '%{BKY_TEXT_LENGTH_TOOLTIP}',
      helpUrl: '%{BKY_TEXT_LENGTH_HELPURL}',
    })
  },
}
// 文本是否为空的判断
Blockly.Blocks['text_isEmpty'] = {
  init: function() {
    this.jsonInit({
      message0: '\u180e%{BKY_TEXT_ISEMPTY_TITLE}',
      args0: [
        {
          type: 'input_value',
          name: 'VALUE',
          check: ['String', 'Array'],
        },
      ],
      output: 'Boolean',
      style: 'text_blocks',
      tooltip: '%{BKY_TEXT_ISEMPTY_TOOLTIP}',
      helpUrl: '%{BKY_TEXT_ISEMPTY_HELPURL}',
    })
  },
}
// 取得文本子字符
Blockly.Blocks['text_getSubstring'] = {
  /**
   * Block for getting substring.
   * @this {Blockly.Block}
   */
  init: function() {
    this['WHERE_OPTIONS_1'] = [
      [Blockly.Msg['TEXT_GET_SUBSTRING_START_FROM_START'], 'FROM_START'],
      [Blockly.Msg['TEXT_GET_SUBSTRING_START_FROM_END'], 'FROM_END'],
      [Blockly.Msg['TEXT_GET_SUBSTRING_START_FIRST'], 'FIRST'],
    ]
    this['WHERE_OPTIONS_2'] = [
      [Blockly.Msg['TEXT_GET_SUBSTRING_END_FROM_START'], 'FROM_START'],
      [Blockly.Msg['TEXT_GET_SUBSTRING_END_FROM_END'], 'FROM_END'],
      [Blockly.Msg['TEXT_GET_SUBSTRING_END_LAST'], 'LAST'],
    ]
    this.setHelpUrl(Blockly.Msg['TEXT_GET_SUBSTRING_HELPURL'])
    this.setStyle('text_blocks')
    this.appendDummyInput().appendField(' ')
    this.appendValueInput('STRING')
      .setCheck('String')

      .appendField(Blockly.Msg['TEXT_GET_SUBSTRING_INPUT_IN_TEXT'])
    this.appendDummyInput('AT1')
    this.appendDummyInput('AT2')
    if (Blockly.Msg['TEXT_GET_SUBSTRING_TAIL']) {
      this.appendDummyInput('TAIL').appendField(
        Blockly.Msg['TEXT_GET_SUBSTRING_TAIL']
      )
    }
    this.setInputsInline(true)
    this.setOutput(true, 'String')
    this.updateAt_(1, true)
    this.updateAt_(2, true)
    this.setTooltip(Blockly.Msg['TEXT_GET_SUBSTRING_TOOLTIP'])
  },
  /**
   * Create XML to represent whether there are 'AT' inputs.
   * @return {!Element} XML storage element.
   * @this {Blockly.Block}
   */
  mutationToDom: function() {
    var container = Blockly.utils.xml.createElement('mutation')
    var isAt1 = this.getInput('AT1').type == Blockly.INPUT_VALUE
    container.setAttribute('at1', isAt1)
    var isAt2 = this.getInput('AT2').type == Blockly.INPUT_VALUE
    container.setAttribute('at2', isAt2)
    return container
  },
  /**
   * Parse XML to restore the 'AT' inputs.
   * @param {!Element} xmlElement XML storage element.
   * @this {Blockly.Block}
   */
  domToMutation: function(xmlElement) {
    var isAt1 = xmlElement.getAttribute('at1') == 'true'
    var isAt2 = xmlElement.getAttribute('at2') == 'true'
    this.updateAt_(1, isAt1)
    this.updateAt_(2, isAt2)
  },
  /**
   * Create or delete an input for a numeric index.
   * This block has two such inputs, independant of each other.
   * @param {number} n Specify first or second input (1 or 2).
   * @param {boolean} isAt True if the input should exist.
   * @private
   * @this {Blockly.Block}
   */
  updateAt_: function(n, isAt) {
    // Create or delete an input for the numeric index.
    // Destroy old 'AT' and 'ORDINAL' inputs.
    this.removeInput('AT' + n)
    this.removeInput('ORDINAL' + n, true)
    // Create either a value 'AT' input or a dummy input.
    if (isAt) {
      this.appendValueInput('AT' + n).setCheck('Number')
      if (Blockly.Msg['ORDINAL_NUMBER_SUFFIX']) {
        this.appendDummyInput('ORDINAL' + n).appendField(
          Blockly.Msg['ORDINAL_NUMBER_SUFFIX']
        )
      }
    } else {
      this.appendDummyInput('AT' + n)
    }
    // Move tail, if present, to end of block.
    if (n == 2 && Blockly.Msg['TEXT_GET_SUBSTRING_TAIL']) {
      this.removeInput('TAIL', true)
      this.appendDummyInput('TAIL').appendField(
        Blockly.Msg['TEXT_GET_SUBSTRING_TAIL']
      )
    }
    var menu = new Blockly.FieldDropdown(this['WHERE_OPTIONS_' + n], function(
      value
    ) {
      var newAt = value == 'FROM_START' || value == 'FROM_END'
      // The 'isAt' variable is available due to this function being a
      // closure.
      if (newAt != isAt) {
        var block = this.getSourceBlock()
        block.updateAt_(n, newAt)
        // This menu has been destroyed and replaced.
        // Update the replacement.
        block.setFieldValue(value, 'WHERE' + n)
        return null
      }
      return undefined
    })

    this.getInput('AT' + n).appendField(menu, 'WHERE' + n)
    if (n == 1) {
      this.moveInputBefore('AT1', 'AT2')
      if (this.getInput('ORDINAL1')) {
        this.moveInputBefore('ORDINAL1', 'AT2')
      }
    }
  },
}

// 字母转为大写、小写
Blockly.Blocks['text_changeCase'] = {
  /**
   * Block for changing capitalization.
   * @this {Blockly.Block}
   */
  init: function() {
    var OPERATORS = [
      [Blockly.Msg['TEXT_CHANGECASE_OPERATOR_UPPERCASE'], 'UPPERCASE'],
      [Blockly.Msg['TEXT_CHANGECASE_OPERATOR_LOWERCASE'], 'LOWERCASE'],
      [Blockly.Msg['TEXT_CHANGECASE_OPERATOR_TITLECASE'], 'TITLECASE'],
    ]
    this.setHelpUrl(Blockly.Msg['TEXT_CHANGECASE_HELPURL'])
    this.setStyle('text_blocks')
    this.appendValueInput('TEXT')
      .setCheck('String')
      .appendField(new Blockly.FieldDropdown(OPERATORS), 'CASE')
    this.setOutput(true, 'String')
    this.setTooltip(Blockly.Msg['TEXT_CHANGECASE_TOOLTIP'])
    this.setInputsInline(true)
  },
}

Blockly.Blocks['lists_split'] = {
  /**
   * Block for splitting text into a list, or joining a list into text.
   * @this {Blockly.Block}
   */
  init: function() {
    // Assign 'this' to a variable for use in the closures below.
    var thisBlock = this
    var dropdown = new Blockly.FieldDropdown(
      [
        [Blockly.Msg['LISTS_SPLIT_LIST_FROM_TEXT'], 'SPLIT'],
        [Blockly.Msg['LISTS_SPLIT_TEXT_FROM_LIST'], 'JOIN'],
      ],
      function(newMode) {
        thisBlock.updateType_(newMode)
      }
    )
    this.setHelpUrl(Blockly.Msg['LISTS_SPLIT_HELPURL'])
    this.setStyle('text_blocks')
    this.appendValueInput('INPUT')
      .setCheck('String')
      .appendField(dropdown, 'MODE')
    this.appendValueInput('DELIM')
      .setCheck('String')
      .appendField(Blockly.Msg['LISTS_SPLIT_WITH_DELIMITER'])
    this.setInputsInline(true)
    this.setOutput(true, 'Array')
    // this.setOutput(true, "Array");
    this.setTooltip(function() {
      var mode = thisBlock.getFieldValue('MODE')
      if (mode == 'SPLIT') {
        return Blockly.Msg['LISTS_SPLIT_TOOLTIP_SPLIT']
      } else if (mode == 'JOIN') {
        return Blockly.Msg['LISTS_SPLIT_TOOLTIP_JOIN']
      }
      throw Error('Unknown mode: ' + mode)
    })
  },
  /**
   * Modify this block to have the correct input and output types.
   * @param {string} newMode Either 'SPLIT' or 'JOIN'.
   * @private
   * @this {Blockly.Block}
   */
  updateType_: function(newMode) {
    var mode = this.getFieldValue('MODE')
    if (mode != newMode) {
      var inputConnection = this.getInput('INPUT').connection
      inputConnection.setShadowDom(null)
      var inputBlock = inputConnection.targetBlock()
      if (inputBlock) {
        inputConnection.disconnect()
        if (inputBlock.isShadow()) {
          inputBlock.dispose()
        } else {
          this.bumpNeighbours()
        }
      }
    }
    if (newMode == 'SPLIT') {
      this.outputConnection.setCheck('Array')
      this.getInput('INPUT').setCheck('String')
    } else {
      this.outputConnection.setCheck('String')
      this.getInput('INPUT').setCheck('Array')
    }
  },
  /**
   * Create XML to represent the input and output types.
   * @return {!Element} XML storage element.
   * @this {Blockly.Block}
   */
  mutationToDom: function() {
    var container = Blockly.utils.xml.createElement('mutation')
    container.setAttribute('mode', this.getFieldValue('MODE'))
    return container
  },
  /**
   * Parse XML to restore the input and output types.
   * @param {!Element} xmlElement XML storage element.
   * @this {Blockly.Block}
   */
  domToMutation: function(xmlElement) {
    this.updateType_(xmlElement.getAttribute('mode'))
  },
}

Blockly.Blocks['lists_split_1'] = {
  /**
   * Block for splitting text into a list, or joining a list into text.
   * @this {Blockly.Block}
   */
  init: function() {
    // Assign 'this' to a variable for use in the closures below.
    var thisBlock = this
    var dropdown = new Blockly.FieldDropdown(
      [
        [Blockly.Msg['LISTS_SPLIT_TEXT_FROM_LIST'], 'JOIN'],
        [Blockly.Msg['LISTS_SPLIT_LIST_FROM_TEXT'], 'SPLIT'],
      ],
      function(newMode) {
        thisBlock.updateType_(newMode)
      }
    )
    this.setHelpUrl(Blockly.Msg['LISTS_SPLIT_1_HELPURL'])
    this.setStyle('text_blocks')
    this.appendValueInput('INPUT')
      .setCheck('String')
      .appendField(dropdown, 'MODE')
    this.appendValueInput('DELIM')
      .setCheck('String')
      .appendField(Blockly.Msg['LISTS_SPLIT_WITH_DELIMITER'])
    this.setInputsInline(true)
    this.setOutput(true, 'Array')
    this.setTooltip(function() {
      var mode = thisBlock.getFieldValue('MODE')
      if (mode == 'SPLIT') {
        return Blockly.Msg['LISTS_SPLIT_TOOLTIP_SPLIT']
      } else if (mode == 'JOIN') {
        return Blockly.Msg['LISTS_SPLIT_TOOLTIP_JOIN']
      }
      throw Error('Unknown mode: ' + mode)
    })
  },
  /**
   * Modify this block to have the correct input and output types.
   * @param {string} newMode Either 'SPLIT' or 'JOIN'.
   * @private
   * @this {Blockly.Block}
   */
  updateType_: function(newMode) {
    var mode = this.getFieldValue('MODE')
    if (mode != newMode) {
      var inputConnection = this.getInput('INPUT').connection
      inputConnection.setShadowDom(null)
      var inputBlock = inputConnection.targetBlock()
      if (inputBlock) {
        inputConnection.disconnect()
        if (inputBlock.isShadow()) {
          inputBlock.dispose()
        } else {
          this.bumpNeighbours()
        }
      }
    }
    if (newMode == 'SPLIT') {
      this.outputConnection.setCheck('Array')
      this.getInput('INPUT').setCheck('String')
    } else {
      this.outputConnection.setCheck('String')
      this.getInput('INPUT').setCheck('Array')
    }
  },
  /**
   * Create XML to represent the input and output types.
   * @return {!Element} XML storage element.
   * @this {Blockly.Block}
   */
  mutationToDom: function() {
    var container = Blockly.utils.xml.createElement('mutation')
    container.setAttribute('mode', this.getFieldValue('MODE'))
    return container
  },
  /**
   * Parse XML to restore the input and output types.
   * @param {!Element} xmlElement XML storage element.
   * @this {Blockly.Block}
   */
  domToMutation: function(xmlElement) {
    this.updateType_(xmlElement.getAttribute('mode'))
  },
}

// 整型、浮点型、字符串型的变量类型的切换
Blockly.Blocks.gta_ai_variable_change = {
  init: function() {
    this.appendDummyInput()
      .appendField('将“')
      .appendField(new Blockly.FieldTextInput(''), 'NAME')
      .appendField('”转换为 ')
      .appendField(
        new Blockly.FieldDropdown([
          ['整数类型', 'int'],
          ['浮点数类型', 'float'],
          ['字符串类型', 'str'],
        ]),
        'NAME1'
      )
    this.setInputsInline(true)
    this.setOutput(true)
    this.setStyle('text_blocks')
    // this.setColour(230)
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['GTA_AI_VARIABLE_CHANGE'])
  },
}
Blockly.Python.gta_ai_variable_change = function(a) {
  var b = a.getFieldValue('NAME')
  var t = a.getFieldValue('NAME1')
  let code = t + "('" + b + "')"
  return [code, Blockly.Python.ORDER_NONE]
}

//可嵌套的积木类型
Blockly.Blocks.gta_ai_variable_change_2 = {
  init: function() {
    this.appendDummyInput().appendField('将“')
    // .appendField(new Blockly.FieldTextInput(""), "NAME")
    this.appendValueInput('NAME').setCheck(null)
    this.appendDummyInput()
      .appendField('”转换为 ')
      .appendField(
        new Blockly.FieldDropdown([
          ['整数类型', 'int'],
          ['浮点数类型', 'float'],
          ['字符串类型', 'str'],
        ]),
        'NAME1'
      )
    this.setInputsInline(true)
    this.setOutput(true)
    this.setStyle('text_blocks')
    // this.setColour(230);
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['GTA_AI_VARIABLE_CHANGE_2'])
  },
}
Blockly.Python.gta_ai_variable_change_2 = function(a) {
  //   var b = a.getFieldValue('NAME')
  var b = Blockly.Python.valueToCode(a, 'NAME', Blockly.Python.ORDER_NONE)
  var t = a.getFieldValue('NAME1')
  var code = t + '(' + b + ')'
  return [code, Blockly.Python.ORDER_NONE]
}

// 字符串（文本） 某字符是否存在于字符串（文本）的判断
Blockly.Blocks.gta_ai_text_include = {
  init: function() {
    this.appendDummyInput()
      .appendField('“')
      .appendField(new Blockly.FieldTextInput('Hello'), 'NAME')
      .appendField('”')
    this.appendDummyInput().appendField(
      new Blockly.FieldDropdown([
        ['存在于', 'in'],
        ['不存在于', 'not in'],
      ]),
      'NAME1'
    )
    this.appendDummyInput()
      .appendField('“')
      .appendField(new Blockly.FieldTextInput('Hello'), 'NAME2')
      .appendField('”')
    this.setInputsInline(true)
    this.setOutput(true, 'Boolean')
    this.setStyle('text_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['ATA_AI_TEXT_INCLUDE_HELPURL'])
  },
}
Blockly.Python.gta_ai_text_include = function(a) {
  var str = a.getFieldValue('NAME')
  var dropdown = a.getFieldValue('NAME1')
  var str1 = a.getFieldValue('NAME2')
  // TODO: Assemble JavaScript into code variable.
  var code = "('" + str + "' " + dropdown + " '" + str1 + "')"
  // TODO: Change ORDER_NONE to the correct strength.
  return [code, Blockly.Python.ORDER_NONE]
}

// 字符串（文本） 某字符是否存在于字符串（文本）的判断
Blockly.Blocks.gta_ai_text_include_2 = {
  init: function() {
    this.appendDummyInput().appendField('“')
    this.appendValueInput('NAME').setCheck(null)
    //   .appendField(new Blockly.FieldTextInput('Hello'), 'NAME')
    this.appendDummyInput().appendField('”')
    this.appendDummyInput().appendField(
      new Blockly.FieldDropdown([
        ['存在于', 'in'],
        ['不存在于', 'not in'],
      ]),
      'NAME1'
    )
    this.appendDummyInput().appendField('“')
    //   .appendField(new Blockly.FieldTextInput('Hello'), 'NAME2')
    this.appendValueInput('NAME2').setCheck(null)
    this.appendDummyInput().appendField('”')
    this.setInputsInline(true)
    this.setOutput(true, 'Boolean')
    this.setStyle('text_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['ATA_AI_TEXT_INCLUDE_2_HELPURL'])
  },
}
Blockly.Python.gta_ai_text_include_2 = function(a) {
  //   var str = a.getFieldValue('NAME')
  var str = Blockly.Python.valueToCode(a, 'NAME', Blockly.Python.ORDER_NONE)
  var dropdown = a.getFieldValue('NAME1')
  //   var str1 = a.getFieldValue('NAME2')
  var str1 = Blockly.Python.valueToCode(a, 'NAME2', Blockly.Python.ORDER_NONE)
  var code = '(' + str + dropdown + str1 + ')'

  return [code, Blockly.Python.ORDER_NONE]
}

// 类型-消除其两侧的积木
Blockly.Blocks['text_trim'] = {
  /**
   * Block for trimming spaces.
   * @this {Blockly.Block}
   */
  init: function() {
    var OPERATORS = [
      [Blockly.Msg['TEXT_TRIM_OPERATOR_BOTH'], 'BOTH'],
      [Blockly.Msg['TEXT_TRIM_OPERATOR_LEFT'], 'LEFT'],
      [Blockly.Msg['TEXT_TRIM_OPERATOR_RIGHT'], 'RIGHT'],
    ]
    this.setHelpUrl(Blockly.Msg['TEXT_TRIM_HELPURL'])
    this.setStyle('text_blocks')
    this.appendValueInput('TEXT')
      .setCheck('String')
      .appendField(new Blockly.FieldDropdown(OPERATORS), 'MODE')
    this.setOutput(true, 'String')
    this.setTooltip(Blockly.Msg['TEXT_TRIM_TOOLTIP'])
    this.setInputsInline(true) //内部连接
  },
}

Blockly.Blocks['text_join'] = {
  init: function() {
    this.jsonInit({
      message0: '',
      output: 'String',
      style: 'text_blocks',
      helpUrl: '%{BKY_TEXT_JOIN_HELPURL}',
      tooltip: '%{BKY_TEXT_JOIN_TOOLTIP}',
      mutator: 'text_join_mutator',
      inputsInline: true,
    })
  },
}

// 列表类型积木

// 列表长度
Blockly.Blocks['lists_length'] = {
  init: function() {
    this.jsonInit({
      message0: '\u180e%{BKY_LISTS_LENGTH_TITLE}',
      args0: [
        {
          type: 'input_value',
          name: 'VALUE',
          check: ['String', 'Array'],
        },
      ],
      output: 'Number',
      style: 'list_blocks',
      tooltip: '%{BKY_LISTS_LENGTH_TOOLTIP}',
      helpUrl: '%{BKY_LISTS_LENGTH_HELPURL}',
    })
  },
}
// 空列表
Blockly.Blocks['lists_isEmpty'] = {
  init: function() {
    this.jsonInit({
      message0: '\u180e%{BKY_LISTS_ISEMPTY_TITLE}',
      args0: [
        {
          type: 'input_value',
          name: 'VALUE',
          check: ['String', 'Array'],
        },
      ],
      output: 'Boolean',
      style: 'list_blocks',
      tooltip: '%{BKY_LISTS_ISEMPTY_TOOLTIP}',
      helpUrl: '%{BKY_LISTS_ISEMPTY_HELPURL}',
    })
  },
}

Blockly.Blocks['lists_create_with'] = {
  /**
   * Block for creating a list with any number of elements of any type.
   * @this {Blockly.Block}
   */
  init: function() {
    this.setHelpUrl(Blockly.Msg['LISTS_CREATE_WITH_HELPURL'])
    this.setStyle('list_blocks')
    this.itemCount_ = 3
    this.updateShape_()
    this.setOutput(true, 'Array')
    this.setInputsInline(true)
    this.setMutator(new Blockly.Mutator(['lists_create_with_item']))
    this.setTooltip(Blockly.Msg['LISTS_CREATE_WITH_TOOLTIP'])
  },
  /**
   * Create XML to represent list inputs.
   * @return {!Element} XML storage element.
   * @this {Blockly.Block}
   */
  mutationToDom: function() {
    var container = Blockly.utils.xml.createElement('mutation')
    container.setAttribute('items', this.itemCount_)
    return container
  },
  /**
   * Parse XML to restore the list inputs.
   * @param {!Element} xmlElement XML storage element.
   * @this {Blockly.Block}
   */
  domToMutation: function(xmlElement) {
    this.itemCount_ = parseInt(xmlElement.getAttribute('items'), 10)
    this.updateShape_()
  },
  /**
   * Populate the mutator's dialog with this block's components.
   * @param {!Blockly.Workspace} workspace Mutator's workspace.
   * @return {!Blockly.Block} Root block in mutator.
   * @this {Blockly.Block}
   */
  decompose: function(workspace) {
    var containerBlock = workspace.newBlock('lists_create_with_container')
    containerBlock.initSvg()
    var connection = containerBlock.getInput('STACK').connection
    for (var i = 0; i < this.itemCount_; i++) {
      var itemBlock = workspace.newBlock('lists_create_with_item')
      itemBlock.initSvg()
      connection.connect(itemBlock.previousConnection)
      connection = itemBlock.nextConnection
    }
    return containerBlock
  },
  /**
   * Reconfigure this block based on the mutator dialog's components.
   * @param {!Blockly.Block} containerBlock Root block in mutator.
   * @this {Blockly.Block}
   */
  compose: function(containerBlock) {
    var itemBlock = containerBlock.getInputTargetBlock('STACK')
    // Count number of inputs.
    var connections = []
    while (itemBlock) {
      connections.push(itemBlock.valueConnection_)
      itemBlock =
        itemBlock.nextConnection && itemBlock.nextConnection.targetBlock()
    }
    // Disconnect any children that don't belong.
    for (var i = 0; i < this.itemCount_; i++) {
      var connection = this.getInput('ADD' + i).connection.targetConnection
      if (connection && connections.indexOf(connection) == -1) {
        connection.disconnect()
      }
    }
    this.itemCount_ = connections.length
    this.updateShape_()
    // Reconnect any child blocks.
    for (let i = 0; i < this.itemCount_; i++) {
      Blockly.Mutator.reconnect(connections[i], this, 'ADD' + i)
    }
  },
  /**
   * Store pointers to any connected child blocks.
   * @param {!Blockly.Block} containerBlock Root block in mutator.
   * @this {Blockly.Block}
   */
  saveConnections: function(containerBlock) {
    var itemBlock = containerBlock.getInputTargetBlock('STACK')
    var i = 0
    while (itemBlock) {
      var input = this.getInput('ADD' + i)
      itemBlock.valueConnection_ = input && input.connection.targetConnection
      i++
      itemBlock =
        itemBlock.nextConnection && itemBlock.nextConnection.targetBlock()
    }
  },
  /**
   * Modify this block to have the correct number of inputs.
   * @private
   * @this {Blockly.Block}
   */
  updateShape_: function() {
    if (this.itemCount_ && this.getInput('EMPTY')) {
      this.removeInput('EMPTY')
    } else if (!this.itemCount_ && !this.getInput('EMPTY')) {
      this.appendDummyInput('EMPTY').appendField(
        Blockly.Msg['LISTS_CREATE_EMPTY_TITLE']
      )
    }
    // Add new inputs.
    for (var i = 0; i < this.itemCount_; i++) {
      if (!this.getInput('ADD' + i)) {
        var input = this.appendValueInput('ADD' + i)
        if (i == 0) {
          input.appendField(Blockly.Msg['LISTS_CREATE_WITH_INPUT_WITH'])
        }
      }
    }
    // Remove deleted inputs.
    while (this.getInput('ADD' + i)) {
      this.removeInput('ADD' + i)
      i++
    }
  },
}

// lists_length 列表的长度
